<template>
  <div class="home">
    <van-nav-bar
      :title="$t('StaffList.title')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-button
        slot="right"
        class="rightBtn"
        style="margin-right: 10px;"
        color="#1989fa"
        @click="$router.push('/newStaff')"
      >
        {{ $t("ShopList.add") }}
      </van-button>
      <!-- <van-icon
        name="./static/img/add_staff.png"
        slot="right"
        @click="$router.push('/newStaff')"
        style="font-size: 24px;"
      /> -->
    </van-nav-bar>
    <van-cell-group>
      <van-cell
        v-for="(staff, index) in staffs"
        :key="index"
        :title="$t('StaffList.account') + staff.account"
        :value="staff.name"
        is-link
        @click="$router.push('/EditStaff/' + staff.id)"
      />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      staffs: []
    };
  },
  mounted: function() {
    this.getStaffList();
  },
  methods: {
    getStaffList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/users"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.staffs = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 20px;
}
.home {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/Staff/StaffList.vue